import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import FormSelect from "components/DigiHapi/FormSelect";
import ImageUpload from "components/CustomUpload/ImageUpload";

import {
	REMOVE_CAMPSITE_IMAGE,
	SET_CAMPSITE_FILES_IMAGES,
	REMOVE_CAMPSITEMAP_IMAGE,
	SET_CAMPSITEMAP_FILES_IMAGES,
	SET_CAMPSITE_NAME,
	SET_CAMPSITE_NAME_ERROR,
	SET_CAMPSITE_REGISTER_KEY,
	ADD_CAMPSITE_CHANNEL,
	DELETE_CAMPSITE_CHANNEL,
	REORDER_CAMPSITE_CHANNELS,
	SET_CAMPSITE_CUSTOM_URI,
	SET_CAMPSITE_STARS,
	SET_CAMPSITE_CUSTOM_URI_ERROR
} from "actions/types";
import { fetchSearchCampsiteCityChannels } from "actions/channel";

import SortableTags from "components/DigiHapi/SortableTags";

class Step1 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, name, customUri } = this.props;

		let success = true;
		if (!name || name.trim().length === 0) {
			dispatch({
				type: SET_CAMPSITE_NAME_ERROR
			});
			success = false;
		}
		if (!customUri || customUri.trim().length === 0) {
			dispatch({
				type: SET_CAMPSITE_CUSTOM_URI_ERROR
			});
			success = false;
		}
		return success;
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_CAMPSITE_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl, out: "logoUri" }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_CAMPSITE_IMAGE
		});
	};

	onCampsiteMapLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_CAMPSITEMAP_FILES_IMAGES,
			payload: [
				{
					name,
					base64: imagePreviewUrl,
					ignoreQualityTransform: true,
					out: "mapUri"
				},
				{ name: name + "-small", base64: imagePreviewUrl, out: "mapSmallUri" }
			]
		});
	};

	onCampsiteMapRemoved = () => {
		this.props.dispatch({
			type: REMOVE_CAMPSITEMAP_IMAGE
		});
	};

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_CAMPSITE_CHANNEL,
				index
			});
		}
	};

	handleReorder = (from, to) => {
		this.props.dispatch({
			type: REORDER_CAMPSITE_CHANNELS,
			from,
			to
		});
	};

	handleAddition = channel => {
		this.props.dispatch({
			type: ADD_CAMPSITE_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchCampsiteCityChannels(
				query,
				this.props.ignoreWeather
			);
		}
	};

	render() {
		const {
			dispatch,
			name,
			nameErrorMsg,
			customUri,
			customUriErrorMsg,
			logoUri,
			mapSmallUri,
			registerkey,
			channels,
			channelsSuggestions,
			stars
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Logo
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onImageLoaded}
						onImageRemoved={this.onImageRemoved}
						photoUri={logoUri}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Plan intéractif
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onCampsiteMapLoaded}
						onImageRemoved={this.onCampsiteMapRemoved}
						photoUri={mapSmallUri}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name || ""}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_NAME,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="URI *"
						id="uri"
						fullWidth
						error={!!customUriErrorMsg}
						helperText={customUriErrorMsg}
						value={customUri || ""}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_CUSTOM_URI,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormSelect
						label="Classification"
						value={stars ? stars : ""}
						options={[0, 1, 2, 3, 4, 5].map(value => ({
							value,
							label: value
						}))}
						onChange={(e, child) =>
							dispatch({
								type: SET_CAMPSITE_STARS,
								payload: child.props.children
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Clé du camping pour rejoindre la communauté"
						id="registerkey"
						fullWidth
						value={registerkey || ""}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_REGISTER_KEY,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormHelperText>
						{
							"Canaux de diffusion depuis lesquelles recevoir publications, bons plans et météo"
						}
					</FormHelperText>
					<SortableTags
						placeholderText="Canaux de diffusion ..."
						tags={channels}
						suggestions={channelsSuggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleDelete}
						onAddition={this.handleAddition}
						onReorder={this.handleReorder}
						suggestionsFilter={() => true}
						onInput={this.onInput}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "whatever"
						}}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		name,
		nameErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels,
		channelsSuggestions,
		customUri,
		customUriErrorMsg,
		stars,
		ignoreWeather
	} = state.campsiteReducer;
	return {
		name,
		nameErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels: Object.values(channels),
		channelsSuggestions: Object.values(channelsSuggestions),
		customUri,
		customUriErrorMsg,
		stars,
		ignoreWeather
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchCampsiteCityChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step1);
